// extracted by mini-css-extract-plugin
export default {"contaner":"contaner__-9dd234f","logo":"logo__-9dd234f","text":"text__-9dd234f"};